<script setup lang="ts">
  // biome-ignore-all lint/suspicious/noExplicitAny: <intentionally any>
  import { computed } from 'vue';
  import type { ActiveFilter, Filter } from '../../../../store';
  import { FilterTypes } from '../../../../utils/filters/filters-utils';
  import DateRangeFilter from '../DateRangeFilter/DateRangeFilter.vue';
  import SelectMultipleFilter from '../SelectMultipleFilter/SelectMultipleFilter.vue';
  import SelectOneFilter from '../SelectOneFilter/SelectOneFilter.vue';
  import SingleDateFilter from '../SingleDateFilter/SingleDateFilter.vue';
  import TypedTextFilter from '../TypedTextFilter/TypedTextFilter.vue';
  import SelectPaginatedFilter from '../SelectPaginatedFilter/SelectPaginatedFilter.vue';

  export type FilterByTypeProps = ActiveFilter &
    Partial<Filter> & { filterNamespace: string };

  const props = defineProps<FilterByTypeProps>();

  const filterComponentByType = computed<any>(() => {
    switch (props.filterType) {
      case FilterTypes.DATE_RANGE:
        return DateRangeFilter;
      case FilterTypes.DATE:
        return SingleDateFilter;
      case FilterTypes.SELECT:
        return SelectOneFilter;
      case FilterTypes.SELECT_MULTIPLE:
        return SelectMultipleFilter;
      case FilterTypes.TYPED_TEXT:
        return TypedTextFilter;
      case FilterTypes.SELECT_PAGINATED:
        return SelectPaginatedFilter;
      default:
        return null;
    }
  });
</script>

<template>
  <component
    v-if="filterComponentByType"
    :is="filterComponentByType"
    v-bind="{ ...$attrs, ...(props) }"
  />
</template>
